import { InjectionToken, Provider } from '@angular/core';
import { ProductWithVariants } from '../models/product';

export const TOKEN_PRODUCT_CONFIG = new InjectionToken<ProductWithVariants>('TokenProductConfig');

export const toProductConfigProvider: (product: ProductWithVariants) => Provider = (product) => ({
    provide: TOKEN_PRODUCT_CONFIG,
    useValue: product,
    multi: true,
});

export const provideProducts = (products: ProductWithVariants[]): Provider[] =>
    products.map((product: ProductWithVariants) => ({
        provide: TOKEN_PRODUCT_CONFIG,
        useValue: product,
        multi: true,
    }));
